import { createReducer } from 'typesafe-actions';
import { ProductErrorState } from '../types';
import {
  PRODUCTS_COMPARE_MANAGE,
  PRODUCTS_COMPARE_LOAD_DATA,
  SEND_PRODUCTS_COMPARE_ACTION,
  MANAGE_PRODUCT_IN_COMPARE_LIST,
  RETRY_LAST_COMPARE_ACTION,
  AllProductsCompareActions,
} from '../actions';
import { INITIAL_PRODUCT_ERROR_STATE } from './constants';

export const errors = createReducer<
  { manage: ProductErrorState; loadData: ProductErrorState },
  AllProductsCompareActions
>({
  manage: INITIAL_PRODUCT_ERROR_STATE,
  loadData: INITIAL_PRODUCT_ERROR_STATE,
})
  .handleAction(PRODUCTS_COMPARE_MANAGE.failure, (state, { payload }) => ({
    ...state,
    manage: payload,
  }))
  .handleAction(
    [PRODUCTS_COMPARE_MANAGE.request, PRODUCTS_COMPARE_MANAGE.success, PRODUCTS_COMPARE_MANAGE.cancel],
    (state) => ({
      ...state,
      manage: INITIAL_PRODUCT_ERROR_STATE,
    }),
  )
  .handleAction(PRODUCTS_COMPARE_LOAD_DATA.failure, (state, { payload }) => ({
    ...state,
    loadData: payload,
  }))
  .handleAction(
    [
      PRODUCTS_COMPARE_LOAD_DATA.request,
      PRODUCTS_COMPARE_LOAD_DATA.success,
      PRODUCTS_COMPARE_LOAD_DATA.cancel,
    ],
    (state) => ({
      ...state,
      loadData: INITIAL_PRODUCT_ERROR_STATE,
    }),
  )
  .handleAction(
    [SEND_PRODUCTS_COMPARE_ACTION, MANAGE_PRODUCT_IN_COMPARE_LIST, RETRY_LAST_COMPARE_ACTION],
    (state) => ({
      ...state,
      manage: INITIAL_PRODUCT_ERROR_STATE,
    }),
  );
